var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('vs-chip',{staticClass:"product-order-status",attrs:{"color":_vm.utilsList.getColorAtivoInativo(_vm.value)}},[_vm._v("\n    "+_vm._s(_vm.utilsList.getAtivoInativo(_vm.value))+"\n  ")])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }